import SocialMedia from '@components/social-media/SocialMedia';
import PhotoItem from '@pages/gallery/PhotoItem';
import { galleryItems } from '@pages/gallery/galleryItems';



const Gallery = (): JSX.Element => {

	return (
		<div className="app-page gallery-page">
			
			<h1>Galerie</h1>

			<p>Milujeme Vaše příběhy &hearts;. Co víc říct&nbsp;- jejich výraz a&nbsp;Vaše spokojenost mluví za vše. Mrkněte na&nbsp;naše sociální sítě, kde každý den přibývají nové fotky a&nbsp;videa čtyřnohých kamarádů. Děkujeme, že jste s&nbsp;námi!</p>

			<div className='gallery-items'>

				{galleryItems.map((x,i) =>
					<PhotoItem item={x} key={`photo-item-${i}`} />)}

			</div>

			<SocialMedia />

		</div>
	);
};

export default Gallery;